import { useEffect, useState } from "react";
import MinhaConta from "@/pages/app/MinhaConta";
import { supabase } from "@/integrations/supabase/client";

export default function MinhaContaPaciente() {
  const [syncVersion, setSyncVersion] = useState(0);

  useEffect(() => {
    let cancelled = false;

    async function syncPatientBasicsToProfile() {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) return;

        const { data: patient, error: patientError } = await supabase
          .from("patients_onboarding")
          .select("full_name, cpf, avatar_url")
          .eq("owner_id", user.id)
          .order("created_at", { ascending: false })
          .limit(1)
          .maybeSingle();

        if (patientError) throw patientError;
        if (!patient) return;
        if (cancelled) return;

        const cpfDigits = (patient.cpf ?? "").replace(/\D/g, "").trim();

        // Garante que Minha Conta (profiles) reflita o que foi salvo no portal do paciente.
        const { error: profileError } = await supabase
          .from("profiles")
          .upsert(
            {
              id: user.id,
              full_name: patient.full_name ?? null,
              cpf: cpfDigits || null,
              avatar_url: patient.avatar_url ?? null,
            },
            { onConflict: "id" }
          );

        if (profileError) throw profileError;
        if (!cancelled) setSyncVersion((v) => v + 1);
      } catch (err) {
        // Silencioso: não bloqueia a página "Minha Conta" se a sync falhar.
        console.error("Error syncing patient profile to Minha Conta:", err);
      }
    }

    syncPatientBasicsToProfile();
    return () => {
      cancelled = true;
    };
  }, []);

  return <MinhaConta key={syncVersion} basePath="/paciente" />;
}
